import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import Table from '@mui/material/Table/Table'
import { Box, styled, TableBody, TableHead, Typography } from '@mui/material'
import { TableHeaderType } from './types'

export const StyledTable = styled(Table)`
  border-collapse: separate;
  border-spacing: 0 5px;
  border: none;
  table-layout: fixed;
  width: 100%;
`

export const StyledTableHeader = styled(TableHead, {
  shouldForwardProp: (prop) => prop !== 'headerType',
})<{
  headerType: TableHeaderType
}>`
  border: none;
  position: sticky;
  top: 0;
  height: 50px;
  z-index: 2;
`
export const StyledTableHeaderCell = styled(TableCell)<{ background?: string }>`
  border: none;
  background: ${({ background }) => background};
  &:first-of-type {
    padding-left: 20px;
  }

  &:last-child {
    padding-right: 40px;
  }
`

export const TableTitle = styled(Typography)`
  display: flex;
  height: 100%;
  gap: 3px;
  align-items: center;
  font-weight: 700;
  font-size: 1rem;
  cursor: pointer;
`

export const StyledTableBody = styled(TableBody, {
  shouldForwardProp: (prop) => prop !== 'headerType',
})<{
  headerType: TableHeaderType
}>`
  &:before {
    line-height: 5px;
    content: '.';
    color: white;
    display: block;
  }
`

export const StyledTableRow = styled(TableRow)<{ outline?: string }>`
  border-radius: 10px;
  outline: ${({ outline }) => outline};
`

export const StyledTableHeaderRow = styled(TableRow)<{ outline?: string }>`
  outline: ${({ outline }) => outline};
  background: white;
  box-shadow:
    0 -4px 0 white,
    0 4px 0 white;
`

export const StyledTableCell = styled(TableCell)`
  height: 50px;
  margin: 10px;
  border: none;
  font-weight: 700;
  padding: 0;

  &:first-of-type {
    div {
      padding-left: 20px;
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
    }
  }

  &:last-child {
    div {
      padding-right: 10px;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
    }
  }
`

export const StyledTableCellContent = styled('div')<{ align?: string }>`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 15px;
  gap: 10px;
  ${({ theme }) => `
    background-color: ${theme.palette.grey[100]};
  `}

  ${({ align }) => `
    justify-content: ${align === 'right' ? 'flex-end' : align === 'center' ? 'center' : 'flex-start'};
  `}
`

export const StyledFilterContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'hasValue',
})<{
  hasValue: boolean
}>(({ hasValue }) => ({
  width: '100%',
  height: '100%',
  background: hasValue ? 'rgba(139,195,74,.32)' : '#efefef',
  borderTop: '1px solid rgb(224, 224, 224)',
  borderBottom: '1px solid rgb(224, 224, 224)',
}))

export const StyledTableHeaderFilterCell = styled(TableCell)`
  height: 50px;
  margin: 10px;
  border: none;
  font-weight: 700;
  padding: 0;

  &:first-of-type {
    padding-left: 10px; //TODO: Discuss with the team
    .styled-filter-container {
      border-left: 1px solid rgb(224, 224, 224);
      padding-left: 0px;
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
    }
  }

  &:last-child {
    // padding-right: 20px; //TODO: Discuss with the team
    .styled-filter-container {
      border-right: 1px solid rgb(224, 224, 224);
      padding-right: 10px;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
    }
  }
`
